<template>
  <div id="app" class="a-page">
    <common-header></common-header>
    <attached-news></attached-news>
    <user-header v-if="access != 'none'"></user-header>

    <breadcrumbs></breadcrumbs>

    <router-view/>

    <common-footer></common-footer>

    <div class="toggle-preload preload-active" v-if="shouldLockScreen">
      <img src="@/assets/img/static/rolling.gif" alt="">
    </div>
  </div>
</template>

<script>
  import CommonHeader from '@/components/CommonHeader'
  import UserHeader from '@/components/UserHeader'
  import CommonFooter from "../components/CommonFooter";
  import Breadcrumbs from '@/components/Breadcrumbs'
  import AttachedNews from "../components/news/AttachedNews";

  export default {
    components: {
      CommonFooter,
      CommonHeader,
      UserHeader,
      Breadcrumbs,
      AttachedNews
    },
    name: 'main-layout',

    computed: {
      access() {
        const isAuthorized = this.$store.state.auth.isAuthorized;
        return isAuthorized ? 'normal-user' : 'none'
      },

      shouldLockScreen() {
        return this.$store.state.auth.locks > 0
      }
    }
  }
</script>

<style scoped>

</style>
